import React from 'react'
import { Dropdown } from '@dd3tech/wiggui/Dropdown'
import { DropdownKeys } from '@/modules/results/components/Filters'
import { PropertyTypes } from '../PropertyTypes'
import Transition from '@dd3tech/wiggui/Transition'
import { Skeleton } from '@dd3tech/wiggui/Skeleton'

interface IProps {
  propertyTypes: string[]
  isOpen: boolean
  isLoading?: boolean
  onChangePropertyType: (value: { property_type: string[] }) => void
  setIsOpen: ({
    isOpen,
    dropdownKey
  }: {
    isOpen: boolean
    dropdownKey: DropdownKeys
  }) => void
  propertyTypeCopy: string
}
export const PropertyTypeDropdown = ({
  propertyTypes,
  propertyTypeCopy,
  isOpen,
  isLoading,
  setIsOpen,
  onChangePropertyType
}: IProps) => {
  const onClose = () => {
    setIsOpen({ isOpen: false, dropdownKey: 'isOpenPropertyType' })
  }
  const onSetIsOpen = (isOpen: boolean) => {
    setIsOpen({ isOpen, dropdownKey: 'isOpenPropertyType' })
  }
  return (
    <Dropdown isOpen={isOpen} setIsOpen={onSetIsOpen} onClose={onClose}>
      <Dropdown.Trigger
        className={`flex flex-col items-start justify-center px-4 py-[6px]  rounded-full cursor-pointer w-[140px] xl:w-[200px] 2xl:w-[260px] ${
          isOpen
            ? 'bg-white shadow-[0px_3px_6px_0px_rgba(34,34,34,0.16)]'
            : 'hover:bg-surface-strokes'
        }`}
      >
        <p className="text-secondary text-xs">Tipo de propiedad</p>
        {isLoading ? (
          <Skeleton className="w-full h-6" width="w-full" height="h-6" />
        ) : (
          <p className="text-base text-primary !truncate max-w-[100px] xl:max-w-[160px] 2xl:max-w-[220px]">
            {propertyTypeCopy}
          </p>
        )}
      </Dropdown.Trigger>
      <Dropdown.Menu className="flex flex-col p-4 rounded-xl border border-surface-strokes shadow-[0px_3px_34px_-2px_rgba(34,34,34,0.20)] max-h-[380px] min-w-[320px] overflow-y-auto">
        <Transition
          className="!flex flex-col gap-4 w-full h-full"
          show={isOpen}
        >
          <PropertyTypes
            onChangePropertyType={onChangePropertyType}
            propertyTypes={propertyTypes}
          />
        </Transition>
      </Dropdown.Menu>
    </Dropdown>
  )
}
